// Local storage utilities for market data quotes
import { QuoteSpec } from '../types';

const QUOTES_KEY = 'quantra_quotes';

export function generateQuoteId(): string {
  return `quote_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`;
}

export function getSavedQuotes(): QuoteSpec[] {
  try {
    const data = localStorage.getItem(QUOTES_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function saveQuote(quote: QuoteSpec): QuoteSpec {
  const quotes = getSavedQuotes();
  const idx = quotes.findIndex(q => q.id === quote.id);
  const now = new Date().toISOString();
  const updated = { ...quote, updatedAt: now, createdAt: quote.createdAt || now };
  if (idx >= 0) quotes[idx] = updated; else quotes.push(updated);
  localStorage.setItem(QUOTES_KEY, JSON.stringify(quotes));
  return updated;
}

export function deleteQuote(id: string): void {
  const quotes = getSavedQuotes().filter(q => q.id !== id);
  localStorage.setItem(QUOTES_KEY, JSON.stringify(quotes));
}

export function getQuoteById(id: string): QuoteSpec | null {
  return getSavedQuotes().find(q => q.id === id) || null;
}

export function saveAllQuotes(quotes: QuoteSpec[]): void {
  localStorage.setItem(QUOTES_KEY, JSON.stringify(quotes));
}
